import { render, staticRenderFns } from "./BrandCreateEdit.vue?vue&type=template&id=94744e9c&scoped=true&"
import script from "./BrandCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BrandCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandCreateEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandCreateEdit.vue?vue&type=style&index=1&id=94744e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94744e9c",
  null
  
)

export default component.exports